/*
 * Two-way link between the standard product detail modal (Manifest, Import)
 * and the four Archive terminals (1970s/80s/90s/2000s) — previously no way
 * to get from one to the other short of navigating by hand.
 *
 * 1. Product detail modal → Terminal: adds a "View In The [decade] Terminal"
 *    link (out.viewInTerminal / out.detailTerminalShow) for any item whose
 *    era matches one of the four decades — jumps straight to that item's own
 *    record there, boot sequence and all. assets/sat-era-catalog-patch.js
 *    already keys every terminal's records by product id, so the same id
 *    the detail modal already has is exactly what each openArchiveXX(id)
 *    needs; no lookup required. Items with no matching era get no link.
 *
 * 2. Terminal → product detail modal: adds a click-to-view-standard handler
 *    (rec70/80/90/00.viewStandard) on each terminal's own record binding, so
 *    clicking that record's photo leaves the terminal and opens the same
 *    item's ordinary detail modal on the storefront — the real, unfiltered
 *    photo, and (unlike a terminal record) the alternate-angle gallery and
 *    Add To Crate. Switches `view` back to 'site' in the same call so the
 *    modal (nested inside the <sc-if isSite> block — see sections/sat-app.liquid)
 *    actually renders instead of staying hidden behind the terminal view.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var DECADE_TOKENS = {
    '1970s': ['1970', '70s'],
    '1980s': ['1980', '80s'],
    '1990s': ['1990', '90s'],
    '2000s': ['2000', '00s']
  };

  function matchDecade(era) {
    var e = String(era || '').toLowerCase();
    for (var decade in DECADE_TOKENS) {
      if (DECADE_TOKENS[decade].some(function (tok) { return e.indexOf(tok) !== -1; })) return decade;
    }
    return null;
  }

  var orig = window.SATComponent.prototype.renderVals;
  window.SATComponent.prototype.renderVals = function () {
    var out = orig.call(this);
    var self = this;

    // ---- 1. detail modal → terminal ----
    if (out.detail) {
      var decade = matchDecade(out.detail.era);
      var detailId = out.detail.id;
      var closeDetail = out.closeDetail;
      out.detailTerminalShow = decade ? 'inline-flex' : 'none';
      out.detailTerminalLabel = decade ? ('View In The ' + decade + ' Terminal →') : '';
      out.viewInTerminal = function () {
        if (typeof closeDetail === 'function') closeDetail();
        if (decade === '1970s') self.open70(detailId);
        else if (decade === '1980s') self.openArchive80(detailId);
        else if (decade === '1990s') self.openArchive90(detailId);
        else if (decade === '2000s') self.openArchive00(detailId);
      };
    } else {
      out.detailTerminalShow = 'none';
    }

    // ---- 2. terminal → detail modal ----
    ['rec70', 'rec80', 'rec90', 'rec00'].forEach(function (key) {
      var rec = out[key];
      if (rec && rec.code) {
        var id = rec.code.replace(/^SAT-/, '');
        out[key] = Object.assign({}, rec, {
          viewStandard: function () { self.setState({ view: 'site', detailId: id }); }
        });
      }
    });

    return out;
  };
})();
